/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function() {
    "use strict";

    angular
        .module("ROGER")

    //
    .controller("ReservationsController", [
        "$scope", "$http", "$sessionStorage", "$uibModal", "$user", "$oidc",
        function($scope, $http, $sessionStorage, $uibModal, user, oidc) {

            $scope.$storage = $sessionStorage;
            $scope.user = user;

            $scope.$watch("$storage.retailer", function(newValue, oldValue) {
                if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                    $scope.browse();
                }
            });

            $scope.list = [];
            $scope.browse = function() {
                return $http.get("/api/reservation", {
                    params: {
                        retailerId: $scope.$storage.retailer.Id
                    },
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    }
                }).then(function(response) {
                    $scope.list = response.data;
                });
            };

            $scope.$watch("language", function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    $scope.browse();
                }
            });

            $scope.isNotAllocated = function(item) {
                if (reservation.AllocationDate == null) {
                    return true;
                } else {
                    return false;
                }
            };

            // Sorting
            $scope.sorting = function(orderName) {
                if ($scope.$storage.reservations.orderName === orderName) {
                    $scope.$storage.reservations.orderDesc = !$scope.$storage.reservations.orderDesc;
                } else {
                    $scope.$storage.reservations.orderName = orderName;
                    $scope.$storage.reservations.orderDesc = false;
                }
            };

            $scope.sortingClass = function(orderName) {
                if ($scope.$storage.reservations.orderName === orderName) {
                    if ($scope.$storage.reservations.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            // Queue detail
            // $scope.showQueueDetail = function (item) {
            //     $uibModal.open({
            //         template: require("./ReservationQueueDetail.html"),
            //         controller: "ReservationQueueDetailController",
            //         resolve: {
            //             reservation: function () {
            //                 return item;
            //             }
            //         }
            //     }).result
            //         .then(function () { }, function () { });
            // };


            // Cancel reservation
            $scope.cancelReservation = function(item) {
                $uibModal.open({
                        template: require("./ReservationCancel.html"),
                        controller: "ReservationCancelController",
                        resolve: {
                            reservation: function() {
                                return item;
                            }
                        }
                    }).result
                    .then(function() {
                        $scope.browse();
                    }, function() {});
            };

            // Change model specification
            $scope.changeModelSpecification = function(item) {
                $uibModal.open({
                        template: require("./ReservationChangeModelSpecification.html"),
                        controller: "ReservationChangeModelSpecificationController",
                        resolve: {
                            reservation: function() {
                                return item;
                            }
                        }
                    }).result
                    .then(function() {
                        $scope.browse();
                    }, function() {});
            };

            // Change note
            $scope.changeNote = function(item) {
                $uibModal.open({
                        template: require("./ReservationChangeNote.html"),
                        controller: "ReservationChangeNoteController",
                        resolve: {
                            reservation: function() {
                                return item;
                            }
                        }
                    }).result
                    .then(function() {}, function() {});
            };

            // Add to order
            $scope.addToOrder = function(item) {
                $uibModal.open({
                        template: require("./ReservationAddToOrder.html"),
                        controller: "ReservationAddToOrderController",
                        resolve: {
                            reservation: function() {
                                return item;
                            }
                        }
                    }).result
                    .then(function() {}, function() {});
            };

            if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                $scope.browse();
            }
        }
    ]);

})();